export const LOCATIONS_ACTIONS = {
    GET_LOCATIONS: 'LOCATIONS_ACTIONS_GET_LOCATIONS',
    GET_ALL: 'LOCATIONS_ACTIONS_GET_ALL',
    FIND: 'LOCATIONS_ACTIONS_FIND',

    SUCCESS: 'LOCATIONS_ACTIONS_SUCCESS',
    ERROR: 'LOCATIONS_ACTIONS_ERROR',
    CLEAN: 'LOCATIONS_ACTIONS_CLEAN',
}